import "./skeleton.css"

export const ListingCardSkeleton: React.FC = () => {
    return (
        <div className=" w-full flex flex-row gap-6 items-start">
            <div className="skeleton_shine basis-2/5 w-full aspect-square rounded-xl">
            </div>
            <div className="flex flex-col h-full gap-3 basis-3/5 justify-between">
                <div className="flex flex-col gap-3">
                    <div className="skeleton_shine w-full h-6 rounded-xl font-medium text-start text-[20px] leading-5"></div>
                    <div className="flex flex-row gap-1 items-center group">
                        <div className="skeleton_shine w-[50%] h-4 rounded-xl flex">
                        </div>
                    </div>
                </div>
                <div className="skeleton_shine rounded-xl h-[100px] font-light text-start text-sm"></div>
            </div>
        </div>
    )
}